import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Text } from '@fluentui/react-components';

import { commonShimProps } from './utils';

// in v8 boxSide refers to the box's position relative to the label
// in v9 boxSide refers to the labels's position relative to the checkbox
const boxSideTranslation = {
  start: 'after',
  end: 'before',
};

const defaultLabelRender = props => (
  <Text size="400" weight="regular"> {props.label} </Text>
);

const CheckboxShimInternal = React.forwardRef((props, ref) => {
  const {
    className,
    label,
    required,
    checked,
    onChange,
    onRenderLabel,
    boxSide,
    indeterminate,
    defaultIndeterminate,
    defaultChecked,
    size,
  } = props;

  const commonV9Props = commonShimProps(props);

  let checkedValue = checked;

  if (indeterminate) {
    // in v8 indeterminate is a boolean
    // in v9 its a string "mixed"
    checkedValue = 'mixed';
  }

  const onChangeWrapper = (e, v9Result) => {
    // in v8 onChange is called with the event and the new checked value directly
    // in v9 onChange is called with the event and an object with the new checked value
    const { checked: checkedResult } = v9Result;

    onChange(e, checkedResult);
  };

  return (
    <Checkbox
      className={className}
      label={onRenderLabel ? onRenderLabel(props, defaultLabelRender) : label}
      required={required}
      checked={checkedValue}
      onChange={onChangeWrapper}
      ref={ref}
      boxSide={boxSideTranslation[boxSide]}
      defaultChecked={defaultIndeterminate || defaultChecked}
      size={size}
      {...commonV9Props}
    />
  );
});

CheckboxShimInternal.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onRenderLabel: PropTypes.func,
  boxSide: PropTypes.oneOf(['start', 'end']),
  indeterminate: PropTypes.bool,
  defaultIndeterminate: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large']),
};

CheckboxShimInternal.defaultProps = {
  className: '',
  label: '',
  required: false,
  checked: undefined,
  onChange: () => {},
  onRenderLabel: null,
  boxSide: 'start',
  indeterminate: undefined,
  defaultIndeterminate: undefined,
  defaultChecked: undefined,
  size: 'large',
};

export const CheckboxShim = CheckboxShimInternal;
